import React from "react";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export default function About() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="about" className="py-12 md:py-20" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <div className="grid lg:grid-cols-2 gap-10 md:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <div className="rounded-3xl overflow-hidden shadow-[0_20px_60px_rgb(0,0,0,0.08)]">
              <img
                src="https://images.unsplash.com/photo-1602421312666-5883f16a7c85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwY2hlZiUyMHJlc3RhdXJhbnR8ZW58MHx8fHwxNzc1ODk0NDk0fDA&ixlib=rb-4.1.0&q=85"
                alt="Smiling professional in white chef uniform"
                className="w-full h-[400px] md:h-[480px] object-cover"
                data-testid="about-image"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="order-1 lg:order-2"
          >
            <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#7CA63A] mb-4 block">About Us</span>
            <h2 className="font-['Outfit'] text-2xl sm:text-3xl lg:text-4xl font-bold text-[#16231A] tracking-tight leading-[1.2] mb-6">
              Practical audits. Clear reports. Better kitchen discipline.
            </h2>

            <div className="space-y-4 text-[#2B4131] leading-relaxed">
              <p>
                Food Safety Partners helps food businesses strengthen hygiene standards through structured food safety audits, inspections and compliance support. We focus on what is happening on the ground, not just what looks good on paper.
              </p>
              <p>
                Our reviews cover kitchen hygiene, food handling, storage practices, sanitation discipline, staff hygiene and operational readiness so owners and managers can identify risks early and improve standards consistently.
              </p>
              <p>
                We also support eligible businesses in the FSSAI license process for restaurants, cafes, food manufacturing units, bakeries and other food establishments.
              </p>
            </div>

            <div className="mt-8 bg-[#EAF0E2] rounded-2xl p-6 border border-[#E3E8DC]">
              <p className="font-['Outfit'] text-lg font-bold text-[#2B4131]">
                Safer Kitchens. Stronger Standards.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
